import styled from 'styled-components'

import { SignInArrowIcon } from '../../lib/icons/sign-in-arrow-icon'

export const SArrow = styled(SignInArrowIcon)`
    margin-left: 10px;
`

export const SButton = styled.button<{
    size: 'xxs' | 'xs' | 'sm' | 'md' | 'lg'
    primary?: boolean
    danger?: boolean
    arrow: boolean
    minWidth?: string
}>`
    && {
        align-items: center;
        background-color: ${({ theme }) => theme.brandColors.CA_Black};
        border: ${({ theme }) => `1px solid ${theme.brandColors.CA_Black}`};
        border-radius: 99em;
        color: ${({ theme }) => theme.brandColors.CA_White};
        cursor: pointer;
        display: flex;
        font-weight: 500;
        font-size: ${({ size }) => {
            if (size === 'xxs' || size === 'xs') return '0.75rem'
            return '1rem'
        }};
        gap: ${({ theme }) => theme.sizing.margin.s};
        justify-content: center;
        text-decoration: none;
        line-height: 1.5em;
        ${({ minWidth }) => (minWidth ? `min-width:${minWidth}` : '')};
        padding: ${({ size, arrow }) => {
            if (size == 'xxs') return '1.5px 10px'
            if (size == 'xs') return '2.5px 20px'
            if (size === 'sm') return '5px 20px'
            if (arrow) return '9px 46px'
            return '10px 30px'
        }};
        transition: all 0.2s ease;
        width: ${({ size }) => (size === 'lg' ? '100%' : 'fit-content')};

        &:disabled,
        &:disabled:hover {
            color: ${({ theme }) => theme.brandColors.CA_White};
            cursor: not-allowed;
            border-color: ${({ theme }) => theme.brandColors.CA_Mid_Gray};
            background-color: ${({ theme }) => theme.brandColors.CA_Mid_Gray};
        }

        &:hover {
            border: ${({ theme }) => `1px solid ${theme.brandColors.CA_Green}`};
            background-color: ${({ theme }) => theme.brandColors.CA_Green};
            opacity: 1;
            color: ${({ theme }) => theme.brandColors.CA_Black};
            text-decoration: none;

            &.filter-dropdown-btn,
            &.consent-btn,
            &.sign-in-btn {
                svg {
                    path {
                        fill: ${({ theme, primary }) =>
                            primary ? theme.brandColors.CA_White : theme.brandColors.CA_Green};
                    }
                }
            }

            &.sign-in-btn {
                svg {
                    transform: translateX(4px);
                }
            }

            &.danger {
                color: ${({ theme }) => theme.font.lightestColor};
                border-color: ${({ theme }) => theme.brandColors.CA_Dark_Coral};
                background-color: ${({ theme }) => theme.brandColors.CA_Dark_Coral};
            }
        }

        &:active {
            color: ${({ theme }) => theme.brandColors.CA_Black};
            background-color: ${({ theme }) => theme.brandColors.CA_Light_Green};
        }

        &.secondary,
        &.ghost {
            color: ${({ theme }) => theme.brandColors.CA_Black};
            background-color: transparent;

            &:hover {
                background-color: ${({ theme }) => theme.brandColors.CA_Light_Gray};
                opacity: 1;
            }

            &:active {
                color: ${({ theme }) => theme.brandColors.CA_Mid_Gray};
            }
        }

        &.ghost {
            border-radius: unset;
            border-color: transparent;
            padding-left: unset;
            padding-right: unset;

            &:hover {
                border-color: transparent;
            }
        }

        &.secondary {
            border: ${({ theme }) => `1px solid ${theme.brandColors.CA_Black}`};

            &:hover {
                border: ${({ theme }) => `1px solid ${theme.brandColors.CA_Black}`};
            }
        }

        &.danger {
            border-color: ${({ theme }) => theme.brandColors.CA_Coral};
            background-color: ${({ theme }) => theme.brandColors.CA_Coral};
        }

        &.action-btn {
            margin-left: auto;
        }

        &.property-btn {
            height: 30px;
            border: 1px solid #006ef0;
            background-color: unset;
            padding: 4px 5px;
            border-radius: 25px;
            text-decoration: none;
            margin-left: 5px;
            font-size: 12px;
            color: #006ef0;
            &:hover {
                opacity: 50%;
                color: ${({ theme }) => theme.brandColors.CA_Blue};
            }
        }
        &.transparent-btn {
            background: transparent;
            padding: 5px;
            border: none;

            &:hover {
                cursor: pointer;
                background-color: ${({ theme }) => theme.brandColors.CA_Light_Gray};
            }
            &:focus {
                background-color: ${({ theme }) => theme.brandColors.CA_Light_Gray};
            }
            &:disabled,
            &:disabled:hover {
                cursor: not-allowed;

                color: ${({ theme }) => theme.brandColors.CA_Dark_Gray};

                svg {
                    path {
                        fill: ${({ theme }) => theme.brandColors.CA_Dark_Gray};
                    }
                }
            }
        }
    }
`
export const SIconContainer = styled.div`
    padding-left: 10px;
    @media (max-width: 600px) {
        padding-left: 4px;
    }
`
